import { styled } from '@linaria/react';

function Pane({ title, children, actions, ...delegated }) {
  return (
    <Wrapper {...delegated}>
      <Header>
        <Title>{title}</Title>
        {actions}
      </Header>
      {children}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-left: var(--encroach-by-left);
  padding-right: var(--encroach-by-right);
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
`;

const Title = styled.p`
  text-transform: uppercase;
  font-size: 1rem;
  line-height: 46px;
  font-weight: var(--font-weight-bold);
  cursor: default;
  margin: 0;
`;

export default Pane;
